var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarPp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 26.0656,
    r: 26.0656,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.855 39.941C18.3543 39.941 17.8272 39.7829 17.4056 39.4666C16.5886 38.8605 16.246 37.78 16.5623 36.8049L18.8287 29.5312L13.0836 24.8666C12.3193 24.2078 12.0294 23.1536 12.372 22.2049C12.7146 21.2561 13.637 20.6236 14.6384 20.6236H21.8857L24.4421 13.7453C24.7847 12.7966 25.707 12.1641 26.7085 12.1641C27.7099 12.1641 28.6323 12.7966 28.9749 13.7453L31.5312 20.6236H38.7785C39.78 20.6236 40.7024 21.2561 41.045 22.2049C41.3876 23.1536 41.0977 24.2341 40.3334 24.893L34.6146 29.5576L36.9865 36.7522C37.3027 37.7273 36.9865 38.8078 36.1695 39.4139C35.3525 40.0464 34.2457 40.0728 33.376 39.5193L26.7348 35.1973L20.1991 39.572C19.8038 39.8356 19.3294 39.9673 18.855 39.9673V39.941Z",
    fill: "url(#paint0_linear_4796_84397)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4796_84397",
    x1: 12.2295,
    y1: 39.9272,
    x2: 43.1956,
    y2: 14.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E71EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#3C8AF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#1E56D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305FDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPp);
export default __webpack_public_path__ + "static/media/starPP.ee0e80485cbde0f9666ae157a5f006bc.svg";
export { ForwardRef as ReactComponent };